<!--  -->
<template>
    <div class="form_data padding-20 bgc box-shadow">
        <div class="search">
            <el-date-picker value-format="yyyy-MM-dd" format="yyyy-MM-dd" v-model="params.date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            <el-input v-model="params.customername" placeholder="请输入参与人"></el-input>
            <el-button class="search_btn" @click="search">搜索</el-button>
            <el-button class="export_btn" @click="exportFormInfo">导出</el-button>
        </div>
        <el-table :data="tabList" style="width: 100%">
            <el-table-column label="参与人" class-name="center" width="170px">
                <template slot-scope="scope">
                    <div class="join">
                        <img :src="scope.row.headerurl" alt="">
                        <p class="name">{{scope.row.custmername}}</p>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="orderdatetime" label="填写时间" width="200px" class-name="center"></el-table-column>
            <el-table-column :label="item.colname" show-overflow-tooltip min-width="200px" :class-name="item.coltype !== 7 ? 'center' : ''" v-for="(item, index) in collist" :key="index">
                <template slot-scope="scope">
                    <div>{{scope.row.colvaluelist[index].colvalue.replace(',', '/')}}</div>
                </template>
            </el-table-column>
        </el-table>
        <Page :total="total" @getList="getCourseUserFormlist" ref="page" />
    </div>
</template>

<script>
import { getCourseUserFormlist, exportFormInfo} from 'api/curriculumApi'
import {mapActions, mapGetters} from 'vuex'
import Page from 'base/page/page'
import {dateFormat} from 'common/js/tools'
export default {
    data() {
        return {
            total: 0,
            collist: [],
            tabList: [],
            params: {
                innerid: this.$route.query.innerid ? this.$route.query.innerid : '',
                customername: '',
                date: [],
                begintime: '',
                endtime: ''
            }
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {
        this.getCourseUserFormlist()
    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        search() {
            this.setPage({page: 1, pageSize: 10})
            if (this.params.date.length) {
                this.params.begintime = this.params.date[0]
                this.params.endtime = this.params.date[1]
            }
            this.getCourseUserFormlist()
        },
        getCourseUserFormlist() {
            this.setLoading(true)
            getCourseUserFormlist({
                data: Object.assign({}, this.page, this.params),
                success: res => {
                    this.setLoading(false)
                    if (this.page.page === 1) {
                        this.collist = res.data.collist
                    }
                    this.tabList = res.data.content
                    this.total = res.data.pageinfo.rowCount
                    console.log(res)
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
        },
        exportFormInfo() {
            if (this.params.date.length) {
                this.params.begintime = this.params.date[0]
                this.params.endtime = this.params.date[1]
            }
            this.setLoading(true)
            exportFormInfo({
                data: this.params,
                success: res => {
                    this.setLoading(false)
                    let blob = new Blob([res], {type: 'application/vnd.ms-excel'})
                    let fileName = dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                },
                error: res => {

                }
            })
        },
        ...mapActions([
            'setLoading',
            'setPage'
        ])
    },
    computed: {
        ...mapGetters(['page'])
    },
    components: {
        Page
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
    .form_data {
        .search {
            display: flex;
            justify-content: flex-end;
            margin-bottom: 30px;
            .el-date-editor {
                margin-right: 30px;
                .el-icon-date {
                    line-height: 24px;
                }
                .el-range-separator {
                    line-height: 24px;
                }
            }
            .el-input {
                width: 220px;
                margin-right: 30px;
            }
            .search_btn {
                margin-right: 30px;
            }
            .export_btn {
                margin: 0;
            }
        }
        .join {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            img {
                width: 60px;
                height: 60px;
                margin-right: 20px;
                border-radius: 50%;
            }
            .name {
                flex: 1;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                text-align: left;
            }
        }
        .center {
            .cell {
                text-align: center;
            }
        }
    }
</style>